// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__XcZwB","icon":"Alert_icon__RSh5d"};